import { render, staticRenderFns } from "./PlatformPayment.vue?vue&type=template&id=58b086dd&scoped=true"
import script from "./PlatformPayment.vue?vue&type=script&lang=js"
export * from "./PlatformPayment.vue?vue&type=script&lang=js"
import style0 from "./PlatformPayment.vue?vue&type=style&index=0&id=58b086dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b086dd",
  null
  
)

export default component.exports